'use client';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Choice, Limit, ColorLimit, SelectionData } from '../questions';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClientComponent from '@/components/builder/client_component';
import cssStyles from "./questioniar_component.module.scss";

export const groupBy = (array: any, key: any) => {
  // Return the end result
  return array.reduce((result: any, currentValue: any) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

const VerticalSingleSelection: React.FC<SelectionData> = ({ setSelectedAnswer, choices, editData, props }) => {

  let previousChoiceId = "";

  const limit = props.colorPallete ? ColorLimit : Limit;

  if (editData && editData.responses && editData.responses.length > 0 &&
    editData.responses[0].answers && editData.responses[0].answers.length > 0) {
    let answer = editData.responses[0].answers[0] as any;

    if (props.colorPallete) {
      const answerArr = editData.responses[0].answers.filter((option: any) => {
        return option.selected
      })

      if (answerArr.length > 0) {
        answer = answerArr[0];
      }
    }

    if (props.isBudgetFlow) {
      const answerArr = editData.responses[0].answers.filter((option: any) => {
        return option.recommended
      })

      if (answerArr.length > 0) {
        answer = answerArr[0];
      }
    }

    previousChoiceId = answer.choiceid;
  }

  const getAnswerObject = (value: string) => {
    const answerObj = choices.filter((eachChoice: Choice) => eachChoice.choiceid === value) as Choice[]
    if (answerObj && answerObj[0]) {
        return {
          choiceid: value,
          answer: props.colorPallete ? answerObj[0].choice.split("-")[0] : answerObj[0].choice
        }
    } else {
        return {
          choiceid: value,
          answer: ''
        }
    }
  }

  useLayoutEffect(() => {
    if (previousChoiceId) {
      setSelectedAnswer([getAnswerObject(previousChoiceId)])
    }
  }, [previousChoiceId])

  const [selectedValue, setSelectedValue] = useState(props.isBudgetFlow ? "2" : previousChoiceId);


  const items = useRef<Choice[]>([]);
  const [updateDOM, setUpdateDOM] = useState(new Date().getMilliseconds());
  const itemsIndex = useRef(0);

  useLayoutEffect(() => {
    if (itemsIndex.current == 0 && itemsIndex.current < limit) {
      //debugger
      handleShowMore(null);
    }
  }, [])

  const handleShowLess = (e: React.MouseEvent<HTMLAnchorElement> | null) => {
    if (e) {
      e.preventDefault();
    }
    itemsIndex.current = limit;
    items.current.length = limit;
    setUpdateDOM(new Date().getMilliseconds())
  }

  const handleShowMore = (e: React.MouseEvent<HTMLAnchorElement> | null) => {
    if (e) {
      e.preventDefault();
    }
    const length = itemsIndex.current + limit > choices.length ? choices.length : itemsIndex.current + limit;
    for (let i = 0; i < choices.length; i++) {
      items.current.push(choices[i]);
    }

    itemsIndex.current = choices.length;
    setUpdateDOM(new Date().getMilliseconds())
  }

  const setStateForColorPallete = (selectedValue: string) => {
    setSelectedAnswer((previousState: any) => {
      let valuePresent = false;
      for (let i = 0; i < previousState.length; i++) {
        if (previousState[i].choiceid == selectedValue) {
          valuePresent = true;
          break;
        }
      }
      if (valuePresent) {
        return previousState;
      }

      return [...previousState, getAnswerObject(selectedValue)]
    })
  }

  useEffect(() => {
    if (selectedValue) {
      if (props.colorPallete) {
        setStateForColorPallete(selectedValue);
      } else {
        setSelectedAnswer([getAnswerObject(selectedValue)])
      }
    }
  }, [selectedValue])

  const setAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
    //local state
    setSelectedValue(event.target.value);
    if (props.colorPallete) {
      setStateForColorPallete(event.target.value);
    } else {
      setSelectedAnswer([getAnswerObject(event.target.value)])
    }
  }

  const getStyleObj = (option: any) => {
    if (props.colorPallete) {
      return option.color;
    }
    return {}
  }

  const getLabel = (option: any) => {

    if (props.colorPallete) {
      return <span style={{ width: "60px", height: "100%", display: "inline-block" }}></span>;
    } else if (props.isBudgetFlow) {
      const checkItems = () => {
        const tickArr = [] as any;
        if (option.services) {
          option.services.split(",").map((eachService: string) => {
            tickArr.push(<div key={eachService} className={cssStyles['each-service']}><CheckCircleIcon sx={{ color: "primary.main" }} />{eachService}</div>)
          })
        }
        return tickArr;
      }

      return <div className={cssStyles['budget-content']}>
        <p className={cssStyles['choice']}>{option.choice}</p>
        <p className={cssStyles['description']}>{option.description}</p>
        <p className={cssStyles['amount']}>{option.amount}</p>
        <p className={cssStyles['services']}>
          {checkItems()}
        </p>
      </div>
    }
    return option.choice
  }


  const renderQuestion = (props: any) => {
    let questionType = '';
    if (props.colorPallete) {
      questionType = 'colorPallete';
    } else if (props.isPersonality) {
      questionType = 'isPersonality';
    } else {
      questionType = 'default';
    }
    switch (questionType) {
      case 'colorPallete':
        return (
          <>
            {items.current.map((option) => {
              return (

                <img style={{ height: "100%", width: "100%" }} key={option.choiceid} src={getStyleObj(option)} className={`${cssStyles.groupBox} ${cssStyles["color-preference"]}`} />

              )
            })}

            {props.colorPallete ? "" : itemsIndex.current < choices.length ? <a href='#' className={cssStyles['show-more']} onClick={handleShowMore}>Show more <MoreVertIcon /></a> : itemsIndex.current <= limit ? "" : <a href='#' className={cssStyles['show-more']} onClick={handleShowLess}>Show less</a>}
          </>
        );
      case 'isPersonality':
        const isPersonalityValues = groupBy(items.current, 'choice');
        return (
          <>

            <FormControl component="fieldset" fullWidth={true} className={cssStyles['personality-question']}>
              <RadioGroup
                aria-label="radio-buttons"
                name="radio-buttons-group"
                className={props.isBudgetFlow ? cssStyles["budget-flow"] : cssStyles["normal-flow"]}
                value={selectedValue}
                onChange={(e) => setAnswer(e)}
              >
                <>
                  {
                    Object.keys(isPersonalityValues).map((key) => {
                      return (
                        <>
                          <div className={cssStyles['label']}>{key}</div>

                          {
                            isPersonalityValues[key].map((option: any) => {
                              const isSelectedValue = option.choiceid == selectedValue;
                              return (
                                <>
                                  {
                                    option.image && option.image !== null &&
                                    <div key={option.choiceid}
                                      className={`${cssStyles.groupBox} ${props.isBudgetFlow ? cssStyles["no-border"] : ""} ${option.recommended == "Yes" ? cssStyles["recomended-radio"] : cssStyles["unrecomended-radio"]} ${isSelectedValue ? cssStyles.selectedBox : cssStyles.unselectedBox} ${props.colorPallete ? cssStyles["color-preference"] : ""}`}>
                                      <div className={cssStyles["image-wrapper"]} style={{
                                        "backgroundImage": `url(${option.image})`
                                      }}></div>
                                      <FormControlLabel
                                        key={option.choiceid}
                                        value={option.choiceid}
                                        data-answer={option.choice}
                                        control={
                                          <Radio
                                            checkedIcon={<RadioButtonCheckedIcon sx={{ color: 'primary.main' }} />}
                                            icon={<RadioButtonCheckedIcon sx={{ color: 'secondary.main' }} />}
                                          />
                                        }
                                        label=""
                                      />
                                    </div>
                                  }
                                </>
                              )
                            })
                          }
                        </>
                      )

                    })
                  }
                </>
              </RadioGroup>
            </FormControl>
          </>
        )
      default:
        return (
          <>
            <FormControl component="fieldset" fullWidth={true} className={`${props.paintPreferences ? cssStyles['get-back-paint'] : ''}`}>
              <RadioGroup
                aria-label="radio-buttons"
                name="radio-buttons-group"
                className={`${props.isBudgetFlow ? cssStyles["budget-flow"] : cssStyles["normal-flow"]} ${props.colorPallete ? cssStyles["singleRow"] : ""}`}
                value={selectedValue}
                onChange={(e) => setAnswer(e)}
              >
                {items.current.map((option) => {
                  const isSelectedValue = option.choiceid == selectedValue;
                  if (props.isBudgetFlow && option.choice == "Enter your Budget") {
                    return (<></>)
                  }
                  return (
                    <div key={option.choiceid} style={getStyleObj(option)} className={`${cssStyles.groupBox} ${props.isBudgetFlow ? cssStyles["no-border"] : ""} ${option.recommended == "Yes" ? cssStyles["recomended-radio"] : cssStyles["unrecomended-radio"]} ${isSelectedValue ? cssStyles["selectedBox"] : cssStyles["unselectedBox"]} ${props.colorPallete ? cssStyles["color-preference"] : ""} ${option.image ? cssStyles["non-group-single-selection"] : ""}`}>
                      {option.image && <div className={cssStyles["image-wrapper"]} style={{
                        "backgroundImage": `url(${option.image})`
                      }}></div>}
                      <FormControlLabel
                        key={option.choiceid}
                        disabled={option.choice.indexOf('coming soon') > -1 ? true : false}
                        value={option.choiceid}
                        data-answer={option.choice}
                        control={
                          option.recommended == "Yes" && !selectedValue ? (
                            <Radio
                              checked={true}
                              checkedIcon={<RadioButtonCheckedIcon sx={{ color: 'primary.main' }} />}
                              icon={<RadioButtonUncheckedIcon sx={{ color: 'secondary.main' }} />}
                            />
                          ) : (
                            <Radio
                              checkedIcon={<RadioButtonCheckedIcon sx={{ color: 'primary.main' }} />}
                              icon={<RadioButtonUncheckedIcon sx={{ color: 'secondary.main' }} />}
                            />
                          )

                        }
                        label={!option.image && getLabel(option)}
                      />
                      {option.image && <div className={cssStyles["image-grid-multi-selection"]}>
                        <span className={cssStyles["choice-backdrop"]}>{option.choice}</span>
                      </div>}
                    </div>
                  )
                })}
              </RadioGroup>
              {props.colorPallete ? "" : itemsIndex.current < choices.length ? <a href='#' className={cssStyles['show-more']} onClick={handleShowMore}>Show more <MoreVertIcon /></a> : itemsIndex.current <= limit ? "" : <a href='#' className={cssStyles['show-more']} onClick={handleShowLess}>Show less</a>}
            </FormControl>
          </>
        );
    }
  }

  return (
    <>
      {renderQuestion(props)}
    </>
  )
}

export default ClientComponent(VerticalSingleSelection);